import React from "react";
import "./TurneroTrucks.css";
import IngresoManual from "../../../components/trucks/turnero/IngresoManualNew";
import { useState, useEffect } from "react";
import {
  Button,
  Col,
  Row,
  Container,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "react-bootstrap";
import Modal2 from "react-modal";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { projectFirestore } from "../../../firebase/config";
import Ticket from "../../../components/trucks/turnero/Ticket";
import Soundmp3 from "../turnero/WhatsApp-Audio-2025-03-25-at-16.47.39.mp3";
import Soundpay from "../turnero/Notif.mp3";
import SoundMix from "../turnero/SoundMix.mp3";
import { DateTime } from "luxon";
import "../../../components/NewButton.css";
import moment from "moment";
import ReactDOM from "react-dom";
import {
  onSnapshot,
  collection,
  query,
  doc,
  where,
  updateDoc,
  addDoc,
  orderBy,
  getDoc,
} from "firebase/firestore";
import {
  Document,
  Font,
  Image,
  Page,
  PDFViewer,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import OrdenLista from "../../../components/trucks/turnero/OrdenList";
import ViewPedidoNew from "../../../components/trucks/turnero/ViewPedidoNew";

export default function TurneroTrucks() {
  const { register, employee } = useAuthContext();
  const [infoModal, setInfoModal] = useState(false);
  const [modQr, setModQr] = useState(false);
  const [modQrNuevo, setModQrNuevo] = useState(false);
  const [textInfo, setTextInfo] = useState("");
  const [busquedac, setBusquedac] = useState(false);
  const [codigoc, setCodigoc] = useState("");
  const [show, setShow] = useState(false);
  const [pagar, setPagar] = useState(false);
  const [emplName, setEmpName] = useState("");
  const [impresion, setImpresion] = useState(false);
  const [showPedido, setShowPedido] = useState(false);
  const [encaja, setEncaja] = useState("");
  const [ordenToView, setOrdenToView] = useState(null);
  const [showTicket, setShowTicket] = useState(false);
  const [ordenToTicket, setOrdenToTicket] = useState(null);
  const [entradas, setEntradas] = useState([]);
  const [salidas, setSalidas] = useState([]);
  const [searchStatus, setSearchStatus] = useState("PENDIENTE");
  const [caja, setCaja] = useState(false);
  const [numPen, setNumPen] = useState(0);
  const [numAte, setNumAte] = useState(0);
  const [numEnt, setNumEnt] = useState(0);
  const [numCom, setNumCom] = useState(0);
  const [numCan, setNumCan] = useState(0);
  const [numMixto, setNumMixto] = useState(0);
  const [orders, setOrders] = useState([]);
  const [fecha, setFecha] = useState("");
  const [newUserOrden, setNewUserOrden] = useState("");
  const [cajaID, setCajaID] = useState();
  const [tipoRegistro, setTipoRegistro] = useState("");
  const [registroData, setRegistroData] = useState(0);
  const [cajadata, setCajadata] = useState(0);
  const [registroNew, setRegistroNew] = useState(false);
  const [resumen, setResumen] = useState(false);
  const customModalInfoStyles = {
    content: {
      width: "600px",
      height: "200px",
      margin: "auto",
      border: "none",
      textAlign: "center",
      borderRadius: "8px",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
    },
  };

  const filteredOrders = orders.filter((order) => {
    if (searchStatus !== "MIXTO") {
      return order.status === searchStatus;
    } else {
      return (
        order.user === encaja &&
        (order.status === "PENDIENTE" ||
          order.status === "ATENDIDO" ||
          order.status === "ENTREGAR" ||
          order.status === "COMPLETADO" ||
          order.status === "CANCELADO")
      );
    }
  });

  const handleClose = () => {
    setShow(false);
    setNewUserOrden("");
  };

  const handleEntradas = () => {
    setRegistroNew(true);
    setRegistroData({
      descripcion: "",
      monto: 0,
    });
    setTipoRegistro("entradas");
  };

  const handleSalidas = () => {
    setRegistroNew(true);
    setRegistroData({
      descripcion: "",
      monto: 0,
    });
    setTipoRegistro("salidas");
  };

  const handleChange = (e) => {
    setCajadata({
      ...cajadata,
      [e.target.name]: e.target.value,
    });
  };

  const saveRegistro = async () => {
    if (!registroData.descripcion || !registroData.monto) {
      alert("Por favor, completa todos los campos.");
      return;
    }
    const registro = {
      fecha: new Date(),
      descripcion: registroData.descripcion,
      monto: parseFloat(registroData.monto),
    };
    if (tipoRegistro === "entradas") {
      await addDoc(
        collection(projectFirestore, "cajas", cajaID, "entradas"),
        registro,
      );
    } else {
      await addDoc(
        collection(projectFirestore, "cajas", cajaID, "salidas"),
        registro,
      );
    }
    setRegistroNew(false);
    setRegistroData({ descripcion: "", monto: 0 });
  };

  const handleShow = () => setShow(true);

  const handleShowPedido = (orden) => {
    console.log(orden);
    setOrdenToView(orden);
    setShowPedido(true);
  };

  const handleClosePedido = () => {
    // if (ordenToView.recoger) {
    //   ordenToView.recoger = false;
    //   updateDoc(doc(projectFirestore, "turnero", ordenToView.id), {
    //     recoger: false,
    //   });
    // }
    if (pagar) {
      setPagar(false);
    }
    setShowPedido(false);
    setOrdenToView(null);
    // fetchData();
  };

  const handleShowTicket = (orden) => {
    console.log(orden);
    setOrdenToTicket(orden);
    setImpresion(true);
    //handleClosePedido();
  };

  const convertToDate = (timestamp) => {
    if (!timestamp) return null;
    const date = new Date(timestamp.seconds * 1000);
    if (date.getHours() > 12) {
      return date.getHours() - 12 + ":" + date.getMinutes() + " PM";
    } else if (date.getHours() === 12) {
      return date.getHours() + ":" + date.getMinutes() + " PM";
    } else if (date.getHours() === 0) {
      return "12:" + date.getMinutes() + " AM";
    } else if (date.getHours() < 10) {
      return "0" + date.getHours() + ":" + date.getMinutes() + " AM";
    } else {
      return date.getHours() + ":" + date.getMinutes() + " AM";
    }
  };

  const handleCloseTicket = () => {
    setShowTicket(false);
    setOrdenToTicket(null);
    // fetchData();
  };

  const handlePendente = () => {
    setSearchStatus("PENDIENTE");
  };

  const handleAtendido = () => {
    setSearchStatus("ATENDIDO");
  };

  const handleEntregar = () => {
    setSearchStatus("ENTREGAR");
  };

  const handleCompletado = () => {
    setSearchStatus("COMPLETADO");
  };

  const handleCancelado = () => {
    setSearchStatus("CANCELADO");
  };

  const handleMixto = () => {
    setSearchStatus("MIXTO");
  };

  //#region PDF Ticket

  Font.register({
    family: "Oswald",
    src: "https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf",
  });

  const styles = StyleSheet.create({
    body: {
      paddingTop: 20,
      paddingBottom: 20,
      paddingHorizontal: 20,
    },
    title: {
      fontSize: 6.5,
      textAlign: "center",
      fontFamily: "Oswald",
    },
    author: {
      fontSize: 3,
      textAlign: "center",
      marginBottom: 40,
    },
    subtitle: {
      fontSize: 6.5,
      textAlign: "center",
      fontFamily: "Oswald",
    },
    text: {
      fontSize: 5.5,
      textAlign: "center",
      fontFamily: "Oswald",
    },
    image: {
      width: 37,
      height: 17,
    },
    row: {
      flexDirection: "row",
    },
    titleprod: {
      flex: 3,
      fontSize: 5.5,
      textAlign: "center",
      margin: 0,
      padding: 0,
      flexGrow: 3,
    },
    titletrow: {
      flex: 1,
      margin: 0,
      fontSize: 5.5,
      padding: 3,
      flexGrow: 3,
    },
    contentrow: {
      flex: 1,
      fontSize: 5.5,
      textAlign: "right",
      margin: 0,
      padding: 3,
      flexGrow: 1,
    },
    header: {
      fontSize: 4,
      marginBottom: 20,
      textAlign: "center",
      color: "grey",
    },
  });

  const App = () => (
    <PDFViewer className="PDFViewer">
      <MyDocument />
    </PDFViewer>
  );

  const MyDocument = () => (
    <Document>
      <Page size={[227, 610]} style={styles.body}>
        <View style={styles.row}>
          <Image
            alt=""
            src={register.imgticket ? register.imgticket : register.img}
            style={{ width: 37, height: 25 }}
          ></Image>
          <View style={styles.contentrow}>
            <Text style={styles.title}>{register.nameticket}</Text>
            <Text style={styles.title}>
              {register.razon_socialticket
                ? "Razon social: " + register.razon_social
                : ""}
            </Text>
            <Text style={styles.title}>
              {register.calleticket
                ? register.calleticket +
                  " #" +
                  register.numdomticket +
                  " Col." +
                  register.coloniaticket +
                  " C.P. " +
                  register.codigopticket
                : ""}
            </Text>
            <Text style={styles.title}>
              {register.municipioticket
                ? register.municipioticket +
                  ", " +
                  register.estadoticket +
                  " " +
                  register.paisticket
                : ""}
            </Text>
            <Text style={styles.subtitle}>
              {register.sucursalticket
                ? "Sucursal:" + register.sucursalticket
                : ""}
            </Text>
            <Text style={styles.subtitle}>
              {register.rfcticket ? "RFC:" + register.rfcticket : ""}
            </Text>
            <Text style={styles.subtitle}>
              {register.phoneticket ? "Telefono: " + register.phoneticket : ""}
            </Text>
          </View>
          <Image
            src="/static/media/logonaranja.47703c147962eb0583b9.png"
            style={[styles.image]}
          ></Image>
        </View>
        <View style={styles.row}>
          <Text
            style={[styles.contentrow, { textAlign: "right", paddingTop: 10 }]}
          >
            Fecha y hora:{" "}
            {new Date().toLocaleDateString() +
              " " +
              new Date().toLocaleTimeString()}
          </Text>
        </View>
        <Text style={{ paddingBottom: 5, fontSize: 5.5 }}>
          Empleado: {employee ? emplName : "Administrador"}
        </Text>
        #region Total en caja
        <>
          <View style={styles.row}>
            <Text style={styles.titleprod}>Total en caja</Text>
          </View>
          <View style={styles.row}></View>
          <View style={styles.row}>
            <Text style={styles.titletrow} fixed>
              Fondo inicial:
            </Text>
            <Text style={styles.contentrow}>
              ${cajadata.fondo ? cajadata.fondo.toFixed(2) : "0.00"} MXN{" "}
            </Text>
          </View>
        </>
        <>
          <View style={styles.row}></View>
          <View style={styles.row}>
            <Text style={styles.titletrow} fixed>
              Total de ventas en efectivo
            </Text>
            <Text style={styles.contentrow}>
              ${totalEfectivo ? totalEfectivo : "0.00"} MXN{" "}
            </Text>
          </View>
        </>
        <>
          <View style={styles.row}></View>
          <View style={styles.row}>
            <Text style={styles.titletrow} fixed>
              Total de entradas
            </Text>
            <Text style={styles.contentrow}>
              $
              {entradas
                ? entradas
                    .reduce((acom, num) => {
                      return acom + num.monto;
                    }, 0)
                    .toFixed(2)
                : "0.00"}{" "}
              MXN
            </Text>
          </View>
        </>
        <>
          <View style={styles.row}></View>
          <View style={styles.row}>
            <Text style={styles.titletrow} fixed>
              Total de salidas
            </Text>
            <Text style={styles.contentrow}>
              -$
              {salidas
                ? salidas
                    .reduce((acom, num) => {
                      return acom + num.monto;
                    }, 0)
                    .toFixed(2)
                : "0.00"}{" "}
              MXN
            </Text>
          </View>
        </>
        <>
          <View style={styles.row}></View>
          <View style={styles.row}>
            <Text style={styles.titletrow} fixed>
              Devoluciones de efectivo
            </Text>
            <Text style={styles.contentrow}>
              -$
              {totalCancelacionesEfectivo} MXN
            </Text>
          </View>
        </>
        <View style={styles.row}>
          <Text style={styles.contentrow}>
            ---------------------------------------------------------------------------------------------------------------
          </Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.titletrow}></Text>
          <Text style={styles.contentrow}>Total:</Text>
          <Text style={styles.contentrow}>
            $
            {(
              parseFloat(cajadata.fondo) +
              parseFloat(totalEfectivo) -
              parseFloat(salidas.reduce((acom, num) => acom + num.monto, 0)) +
              parseFloat(entradas.reduce((acom, num) => acom + num.monto, 0)) -
              parseFloat(totalCancelacionesEfectivo)
            ).toFixed(2)}{" "}
            MXN
          </Text>
        </View>
        #endregion #region Total de ventas
        <>
          <View style={styles.row}>
            <Text style={styles.titleprod}>Total de ventas</Text>
          </View>
          <View style={styles.row}></View>
          <View style={styles.row}>
            <Text style={styles.titletrow} fixed>
              Total de ventas en efectivo
            </Text>
            <Text style={styles.contentrow}>
              ${totalEfectivo ? totalEfectivo : "0.00"} MXN{" "}
            </Text>
          </View>
        </>
        <>
          <View style={styles.row}></View>
          <View style={styles.row}>
            <Text style={styles.titletrow} fixed>
              Total de ventas con tarjeta
            </Text>
            <Text style={styles.contentrow}>
              ${totalTarjeta ? totalTarjeta : "0.00"} MXN{" "}
            </Text>
          </View>
        </>
        <>
          <View style={styles.row}></View>
          <View style={styles.row}>
            <Text style={styles.titletrow} fixed>
              Total de cancelaciones/devoluciones
            </Text>
            <Text style={styles.contentrow}>
              -$
              {totalCancelaciones} MXN
            </Text>
          </View>
        </>
        <View style={styles.row}>
          <Text style={styles.contentrow}>
            ---------------------------------------------------------------------------------------------------------------
          </Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.titletrow}></Text>
          <Text style={styles.contentrow}>Total:</Text>
          <Text style={styles.contentrow}>
            $
            {(
              parseFloat(totalTarjeta) +
              parseFloat(totalEfectivo) -
              parseFloat(totalCancelaciones)
            ).toFixed(2)}{" "}
            MXN
          </Text>
        </View>
        #endregion #region Entradas
        <>
          <View style={styles.row}>
            <Text style={styles.titleprod}>Total de entradas</Text>
          </View>
          {entradas.map((ent) => (
            <>
              <View style={styles.row}></View>
              <View style={styles.row}>
                <Text style={styles.titletrow} fixed>
                  {ent.descripcion}
                </Text>
                <Text style={styles.contentrow}>
                  ${ent.monto.toFixed(2)} MXN
                </Text>
              </View>
            </>
          ))}
        </>
        <View style={styles.row}>
          <Text style={styles.contentrow}>
            ---------------------------------------------------------------------------------------------------------------
          </Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.titletrow}></Text>
          <Text style={styles.contentrow}>Total:</Text>
          <Text style={styles.contentrow}>
            $
            {entradas
              ? entradas.reduce((acom, num) => acom + num.monto, 0).toFixed(2)
              : "0.00"}{" "}
            MXN
          </Text>
        </View>
        #endregion #region Salidas
        <>
          <View style={styles.row}>
            <Text style={styles.titleprod}>Total de salidas</Text>
          </View>
          {salidas.map((ent) => (
            <>
              <View style={styles.row}></View>
              <View style={styles.row}>
                <Text style={styles.titletrow} fixed>
                  {ent.descripcion}
                </Text>
                <Text style={styles.contentrow}>
                  ${ent.monto.toFixed(2)} MXN
                </Text>
              </View>
            </>
          ))}
        </>
        <View style={styles.row}>
          <Text style={styles.contentrow}>
            ---------------------------------------------------------------------------------------------------------------
          </Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.titletrow}></Text>
          <Text style={styles.contentrow}>Total:</Text>
          <Text style={styles.contentrow}>
            $
            {salidas
              ? salidas.reduce((acom, num) => acom + num.monto, 0).toFixed(2)
              : "0.00"}{" "}
            MXN
          </Text>
        </View>
        #endregion #region Puntos
        <>
          <View style={styles.row}>
            <Text style={styles.titleprod}>Puntos</Text>
          </View>
          <>
            <View style={styles.row}></View>
            <View style={styles.row}>
              <Text style={styles.titletrow} fixed>
                Puntos canjeados
              </Text>
              <Text style={styles.contentrow}>
                {orders
                  ? orders
                      .filter(
                        (order) =>
                          (order.status === "COMPLETADO" ||
                            order.status === "ENTREGAR" ||
                            order.status === "ATENDIDO") &&
                          (employee
                            ? order.atendio === employee.id_usuario
                            : order.atendio === "Administrador") &&
                          order.caja === cajaID,
                      )
                      .reduce((acom, num) => {
                        if (num.puntosusados) {
                          return acom + parseFloat(num.puntosusados);
                        } else {
                          return acom + 0;
                        }
                      }, 0)
                  : "0"}{" "}
                puntos
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.titletrow} fixed>
                Puntos otorgados
              </Text>
              <Text style={styles.contentrow}>
                {orders
                  ? orders
                      .filter(
                        (order) =>
                          (order.status === "COMPLETADO" ||
                            order.status === "ENTREGAR" ||
                            order.status === "ATENDIDO") &&
                          (employee
                            ? order.atendio === employee.id_usuario
                            : order.atendio === "Administrador") &&
                          order.caja === cajaID,
                      )
                      .reduce((acom, num) => {
                        if (num.puntosgenerados) {
                          return acom + parseFloat(num.puntosgenerados);
                        } else {
                          return acom + 0;
                        }
                      }, 0)
                  : "0"}{" "}
                puntos
              </Text>
            </View>
          </>
        </>
        #endregion #region Puntos
        <>
          <View style={styles.row}>
            <Text style={styles.titleprod}>MercadoPago</Text>
          </View>
          <>
            <View style={styles.row}></View>
            <View style={styles.row}>
              <Text style={styles.titletrow} fixed>
                Total de ventas con MercadoPago
              </Text>
              <Text style={styles.contentrow}>
                $
                {orders
                  ? orders
                      .filter(
                        (order) =>
                          (order.status === "COMPLETADO" ||
                            order.status === "ENTREGAR" ||
                            order.status === "ATENDIDO") &&
                          order.tipo_pago === "Mercado Pago",
                      )
                      .reduce(
                        (acom, num) =>
                          acom +
                          parseFloat(num.total) -
                          parseFloat(num.puntosusados),
                        0,
                      )
                      .toFixed(2)
                  : "0.00"}{" "}
                MXN
              </Text>
            </View>
          </>
        </>
        #endregion
      </Page>
    </Document>
  );

  const Imprimir = () => {
    var myWindow = window.open("", "MsgWindow");
    myWindow.document.write(
      '<html><head><title>Ticket de venta</title><link rel="icon" href="/favicon.ico"><style type="text/css">html, body, div, iframe { margin:0; padding:0; height:100%; }iframe { display:block; width:100%; border:none; }</style></head><body>',
    );
    myWindow.document.write("</body></html>");
    ReactDOM.render(<App />, myWindow.document.body);
  };
  //#endregion

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp.seconds * 1000);
    const formattedDate = date.toLocaleDateString();
    const formattedTime = date.toLocaleTimeString();
    return {
      date: formattedDate,
      time: formattedTime,
    };
  };

  const saveCierre = async () => {
    if (!cajadata.fondo || !cajadata.tipocambio) {
      alert("Por favor, completa todos los campos.");
      return;
    }
    const cierreData = {
      fechaCierre: new Date(),
      totalEfectivo: totalEfectivo,
      totalTarjeta: totalTarjeta,
      puntosCanjeados: puntosCanjeados,
      puntosOtorgados: puntosOtorgados,
      totalCancelaciones: totalCancelaciones,
      totalCancelacionesEfectivo: totalCancelacionesEfectivo,
      totalMercadoPago: totalMercadoPago,
      totalEntradas: entradas
        ? entradas.reduce((acom, num) => acom + num.monto, 0).toFixed(2)
        : "0.00",
      totalSalidas: salidas
        ? salidas.reduce((acom, num) => acom + num.monto, 0).toFixed(2)
        : "0.00",
      totalCaja: (
        parseFloat(cajadata.fondo) +
        parseFloat(totalEfectivo) +
        parseFloat(totalTarjeta) +
        parseFloat(
          entradas ? entradas.reduce((acom, num) => acom + num.monto, 0) : 0,
        ) -
        parseFloat(
          salidas ? salidas.reduce((acom, num) => acom + num.monto, 0) : 0,
        ) -
        parseFloat(totalCancelaciones)
      ).toFixed(2),
    };
    updateDoc(doc(projectFirestore, "cajas", cajaID), cierreData)
      .then(() => {
        alert("Cierre de caja realizado con éxito.");
        setCaja(false);
        setCajaID(null);
        setCajadata({ fondo: "", tipocambio: "" });
      })
      .catch((error) => {
        console.error("Error al realizar el cierre de caja:", error);
        alert("Error al realizar el cierre de caja. Inténtalo de nuevo.");
      });
  };

  const handleInfo = async (e) => {
    setTextInfo(e.target.title);
    setInfoModal(true);
  };

  const realizarBusqueda = async (e) => {
    let found = orders.find((element) => element.id === codigoc);
    if (found) {
      setOrdenToView(found);
      setShowPedido(true);
      setCodigoc("");
    } else {
      alert("No se encontro la orden");
    }
  };

  const totalMercadoPago = orders
    ? orders
        .filter(
          (ord) =>
            (ord.status === "COMPLETADO" ||
              ord.status === "ENTREGAR" ||
              ord.status === "ATENDIDO" ||
              ord.status === "CANCELADO") &&
            ord.tipo_pago === "Mercado Pago",
        )
        .reduce((acom, num) => acom + num.total - num.puntosusados, 0)
        .toFixed(2)
    : "0.00";

  const totalCancelacionesEfectivo = orders
    ? orders
        .filter(
          (ord) =>
            ord.status === "CANCELADO" &&
            (employee
              ? ord.atendio === employee.id_usuario
              : ord.atendio === "Administrador") &&
            ord.tipo_pago === "Efectivo" &&
            ord.caja === cajaID &&
            ord.cobro,
        )
        .reduce((acom, num) => acom + num.total - num.puntosusados, 0)
        .toFixed(2)
    : "0.00";

  const totalCancelaciones = orders
    ? orders
        .filter(
          (ord) =>
            ord.status === "CANCELADO" &&
            (employee
              ? ord.atendio === employee.id_usuario
              : ord.atendio === "Administrador") &&
            ord.caja === cajaID &&
            ord.cobro,
        )
        .reduce((acom, num) => acom + num.total - num.puntosusados, 0)
        .toFixed(2)
    : "0.00";

  const totalEfectivo = orders
    ? orders
        .filter(
          (order) =>
            (order.status === "COMPLETADO" ||
              order.status === "ENTREGAR" ||
              order.status === "ATENDIDO" ||
              order.status === "CANCELADO") &&
            (employee
              ? order.atendio === employee.id_usuario
              : order.atendio === "Administrador") &&
            order.tipo_pago === "Efectivo" &&
            order.caja === cajaID,
        )
        .reduce((acom, num) => {
          return acom + num.total - num.puntosusados;
        }, 0)
        .toFixed(2)
    : "0.00";

  const puntosCanjeados = orders
    ? orders
        .filter(
          (order) =>
            (order.status === "COMPLETADO" ||
              order.status === "ENTREGAR" ||
              order.status === "ATENDIDO") &&
            (employee
              ? order.atendio === employee.id_usuario
              : order.atendio === "Administrador") &&
            order.caja === cajaID,
        )
        .reduce((acom, num) => {
          if (num.puntosusados) {
            return acom + parseFloat(num.puntosusados);
          } else {
            return acom + 0;
          }
        }, 0)
    : "0";

  const puntosOtorgados = orders
    ? orders
        .filter(
          (order) =>
            (order.status === "COMPLETADO" ||
              order.status === "ENTREGAR" ||
              order.status === "ATENDIDO") &&
            (employee
              ? order.atendio === employee.id_usuario
              : order.atendio === "Administrador") &&
            order.caja === cajaID,
        )
        .reduce((acom, num) => {
          if (num.puntosgenerados) {
            return acom + parseFloat(num.puntosgenerados);
          } else {
            return acom + 0;
          }
        }, 0)
    : "0";

  const totalTarjeta = orders
    ? orders
        .filter(
          (order) =>
            (order.status === "COMPLETADO" ||
              order.status === "ENTREGAR" ||
              order.status === "ATENDIDO" ||
              order.status === "CANCELADO") &&
            (employee
              ? order.atendio === employee.id_usuario
              : order.atendio === "Administrador") &&
            order.tipo_pago === "Tarjeta" &&
            order.caja === cajaID,
        )
        .reduce((acom, num) => {
          return acom + num.total - num.puntosusados;
        }, 0)
        .toFixed(2)
    : "0.00";

  const createCaja = async () => {
    const btnNcaja = document.getElementById("new-cajaBtn");
    btnNcaja.disabled = true;
    if (!cajadata.fondo || !cajadata.tipocambio) {
      alert("Por favor, completa todos los campos.");
      btnNcaja.disabled = false;
      return;
    }
    const cajaData = {
      id_empleado: employee ? employee.id : "",
      puesto: register.id,
      fecha: new Date(),
      fondo: parseFloat(cajadata.fondo),
      tipocambio: parseFloat(cajadata.tipocambio),
    };
    const entradas = {
      fecha: new Date(),
      descripcion: "Apertura de caja",
      monto: 0,
    };
    const salidas = {
      fecha: new Date(),
      descripcion: "Apertura de caja",
      monto: 0,
    };
    const datosid = await addDoc(
      collection(projectFirestore, "cajas"),
      cajaData,
    );
    setCajaID(datosid.id);
    addDoc(
      collection(projectFirestore, "cajas", datosid.id, "entradas"),
      entradas,
    );
    addDoc(
      collection(projectFirestore, "cajas", datosid.id, "salidas"),
      salidas,
    );
    btnNcaja.disabled = false;
  };

  const cleanMixto = async () => {
    if (encaja === "") {
      return;
    }
    setEncaja("");
    updateDoc(doc(projectFirestore, "registro", register.id), {
      enTurno: "",
    });
  };

  useEffect(() => {
    let song = new Audio(Soundmp3);
    let soundpay = new Audio(Soundpay);
    let soundMix = new Audio(SoundMix);
    if (employee) {
      const docname = getDoc(
        doc(projectFirestore, "users", employee.id_usuario),
      );
      docname
        .then((docum) => {
          if (docum.exists()) {
            const data = docum.data();
            setEmpName(data.fullName);
          } else {
            console.log("No such document!");
          }
        })
        .catch((error) => {
          console.log("Error al consultar el documento:", error);
        });
    } else {
      setEmpName("Administrador");
    }
    const localTimeZone = "America/Hermosillo";
    const currentDate = DateTime.now().setZone(localTimeZone);
    const startOfDay = currentDate.startOf("day");
    setFecha(moment(startOfDay).format("DD/MM/YYYY"));
    let fechaact = new Date();
    fechaact.setHours(fechaact.getHours() - 12);
    let w = query(collection(projectFirestore, "cajas"));
    w = query(w, where("puesto", "==", register.id));
    if (employee) {
      w = query(w, where("id_empleado", "==", employee.id));
    } else {
      w = query(w, where("id_empleado", "==", ""));
    }
    w = query(w, orderBy("fecha", "desc"));
    onSnapshot(w, (docume) => {
      if (docume.empty) {
        setCaja(false);
        setCajaID(null);
        setCajadata({ fondo: "", tipocambio: "" });
        setRegistroNew(false);
        setResumen(false);
        setOrders([]);
        setEntradas([]);
        setSalidas([]);
        document.title = "Turnero";
      } else if (docume.docs[0].data().fechaCierre) {
        setCaja(false);
        setCaja(false);
        setCajaID(null);
        setCajadata({ fondo: "", tipocambio: "" });
        setRegistroNew(false);
        setResumen(false);
        setOrders([]);
        setEntradas([]);
        setSalidas([]);
      } else {
        setCaja(true);
        var documentData = docume.docs[0].data();
        setCajadata(documentData);
        setCajaID(docume.docs[0].id);
        let fech = new Date(docume.docs[0].data().fecha.seconds * 1000);
        fech.setHours(0, 0, 0, 0);
        const filtros = [
          { campo: "puesto", operador: "==", valor: register.id },
          { campo: "fecha", operador: ">=", valor: fech },
        ];
        let q = query(collection(projectFirestore, "turnero"));
        filtros.forEach((filtro) => {
          const { campo, operador, valor } = filtro;
          q = query(q, where(campo, operador, valor));
        });
        onSnapshot(q, (docs) => {
          let showPedidoLocal = 0;
          const documentosColeccion = [];
          let numPendiente = 0,
            numAtendido = 0,
            numEntregar = 0,
            numCompletado = 0,
            numCancelado = 0;
          docs.docs.forEach((docu) => {
            const data = docu.data();
            data.id = docu.id;
            if (data.status && data.status === "PENDIENTE") {
              numPendiente++;
            }
            if (data.status && data.status === "ATENDIDO") {
              numAtendido++;
            }
            if (data.status && data.status === "ENTREGAR") {
              numEntregar++;
            }
            if (data.status && data.status === "COMPLETADO") {
              numCompletado++;
            }
            if (data.status && data.status === "CANCELADO") {
              numCancelado++;
            }
            // if (data.recoger) {
            //   showPedidoLocal++;
            // }
            if (data.payonline) {
              soundpay.play();
              updateDoc(doc(projectFirestore, "turnero", docu.id), {
                payonline: false,
              });
            }
            if (data.nueva) {
              song.play();
              updateDoc(doc(projectFirestore, "turnero", docu.id), {
                nueva: false,
              });
            }
            documentosColeccion.push(data);
          });
          setNumPen(numPendiente);
          setNumAte(numAtendido);
          setNumEnt(numEntregar);
          setNumMixto(showPedidoLocal);
          let cant = numPendiente + numAtendido + numEntregar;
          document.title = "Turnero (" + cant + ")";
          setNumCom(numCompletado);
          setNumCan(numCancelado);
          setOrders(documentosColeccion);
        });
        onSnapshot(
          doc(projectFirestore, "registro", register.id),
          (docu) => {
            if (docu.exists()) {
              const data = docu.data();
              if (data.enTurno && data.enTurno !== "") {
                setEncaja(data.enTurno);
                setSearchStatus("MIXTO");
                soundMix.play();
              }
              if (
                data.ordenNueva &&
                data.ordenNueva !== "" &&
                newUserOrden === ""
              ) {
                setNewUserOrden(data.ordenNueva);
                setModQrNuevo(false);
                setShow(true);
                updateDoc(doc(projectFirestore, "registro", register.id), {
                  ordenNueva: "",
                });
              }
            }
          },
          (error) => {
            alert("Error al consultar las salidas: " + error);
          },
        );
        onSnapshot(
          collection(projectFirestore, "cajas", docume.docs[0].id, "entradas"),
          (docs) => {
            const entradasData = [];
            docs.docs.forEach((docu) => {
              const data = docu.data();
              data.id = docu.id;
              entradasData.push(data);
            });
            setEntradas(entradasData);
          },
        );
        onSnapshot(
          collection(projectFirestore, "cajas", docume.docs[0].id, "salidas"),
          (docs) => {
            const salidasData = [];
            docs.docs.forEach((docu) => {
              const data = docu.data();
              data.id = docu.id;
              salidasData.push(data);
            });
            setSalidas(salidasData);
          },
        );
      }
    });
    if (employee && employee.barra) {
      handleAtendido();
    }
  }, [employee, newUserOrden, register.id]);

  return (
    <>
      <Container>
        {caja ? (
          <>
            <Row>
              <Col xs={12} md={12} lg={12} xl={6}>
                <h2 className="page-title margen">
                  TURNOS{" "}
                  {searchStatus === "ENTREGAR"
                    ? "ENTREGAR"
                    : searchStatus + "S"}{" "}
                  {fecha}
                </h2>
              </Col>
              {employee && employee.barra ? (
                <></>
              ) : (
                <>
                  <Col
                    xs={12}
                    md={12}
                    lg={12}
                    xl={6}
                    className="text-right"
                    style={{
                      alignContent: "space-evenly",
                    }}
                  >
                    <Button
                      onClick={(e) => {
                        e.preventDefault();
                        setBusquedac(true);
                      }}
                      variant="ds"
                      className="newbutton-style nonfilledtext-color"
                    >
                      <i className="bx bx-search icon"></i>
                      Buscar orden
                    </Button>
                    <Button
                      onClick={handleEntradas}
                      variant="ds"
                      className="newbutton-style nonfilledtext-color"
                    >
                      Entradas
                    </Button>
                    <Button
                      onClick={handleSalidas}
                      variant="ds"
                      className="newbutton-style nonfilledtext-color"
                    >
                      Salidas
                    </Button>
                    <Button
                      onClick={() => setResumen(true)}
                      variant="ds"
                      className="newbutton-style nonfilledtext-color"
                    >
                      Corte de caja
                    </Button>
                  </Col>
                </>
              )}
            </Row>
            <>
              <Row>
                <Col
                  xs={12}
                  md={12}
                  lg={12}
                  xl={5}
                  style={{ marginBottom: 10 }}
                >
                  <Button
                    variant="ds"
                    className="newbutton-style filled"
                    onClick={(e) => setModQr(true)}
                  >
                    QR Mixto
                  </Button>
                  <Button
                    variant="ds"
                    className="newbutton-style filled"
                    onClick={(e) => setModQrNuevo(true)}
                  >
                    QR Nueva orden
                  </Button>
                  {!employee && !employee?.barra && (
                    <Button
                      variant="ds"
                      className="newbutton-style filled"
                      onClick={handleShow}
                    >
                      INGRESO MANUAL
                    </Button>
                  )}
                </Col>
                <Col xs={12} md={12} lg={12} xl={7}>
                  {encaja && (
                    <Button
                      variant="ds"
                      className="newbutton-style nonfilledtext-color"
                      id="Mixto"
                      onClick={handleMixto}
                    >
                      {" "}
                      Mixto QR {numMixto > 0 ? "(" + numMixto + ")" : ""}
                    </Button>
                  )}

                  {/* <Button variant="info" id="Preventa" onClick={handleMixto}>
                    {" "}
                    PREVENTA
                  </Button> */}
                  {employee && employee.barra ? (
                    <></>
                  ) : (
                    <Button
                      variant="ds"
                      className="newbutton-style nonfilledtext-color"
                      id="Pendiente"
                      onClick={handlePendente}
                    >
                      {" "}
                      Pendiente {numPen > 0 ? "(" + numPen + ")" : ""}
                    </Button>
                  )}
                  <Button
                    variant="ds"
                    className="newbutton-style nonfilledtext-color"
                    id="Atendido"
                    onClick={handleAtendido}
                  >
                    {" "}
                    Atendidos {numAte > 0 ? "(" + numAte + ")" : ""}
                  </Button>
                  <Button
                    variant="ds"
                    className="newbutton-style nonfilledtext-color"
                    id="Entregar"
                    onClick={handleEntregar}
                  >
                    {" "}
                    Entregar {numEnt > 0 ? "(" + numEnt + ")" : ""}
                  </Button>
                  {employee && employee.barra ? (
                    <></>
                  ) : (
                    <>
                      <Button
                        variant="ds"
                        className="newbutton-style nonfilledtext-color"
                        id="Completado"
                        onClick={handleCompletado}
                      >
                        {" "}
                        Completado {numCom > 0 ? "(" + numCom + ")" : ""}
                      </Button>
                      <Button
                        variant="ds"
                        className="newbutton-style nonfilledtext-color"
                        id="Cancelado"
                        onClick={handleCancelado}
                      >
                        {" "}
                        Cancelado {numCan > 0 ? "(" + numCan + ")" : ""}
                      </Button>
                    </>
                  )}
                </Col>
              </Row>
              <hr id="hr" />
            </>
            {/*CONTENEDOR ORDENES (PENDIENTES,ATENDIDAS,ETREGADAS,COMPLETADAS)*/}
            <Container className="order-container">
              {encaja !== "" ? (
                <button onClick={cleanMixto} className="newbutton-style filled">
                  Limpiar ordenes
                </button>
              ) : (
                ""
              )}
              <Row className="justify-content-center">
                {filteredOrders.map((orden) => {
                  const { date, time } = formatTimestamp(orden.fecha);
                  return (
                    <OrdenLista
                      fecha={date}
                      hora={time}
                      orden={orden}
                      register={register}
                      employee={employee}
                      cajaID={cajaID}
                      handleimprimir={handleShowTicket}
                      openPedido={handleShowPedido}
                      // fetchData={fetchData}
                      // openTicket={handleShowTicket}
                      mixto={searchStatus === "MIXTO"}
                      vencimiento={
                        searchStatus === "PENDIENTE" &&
                        register.limitecom &&
                        register.tiempocom
                      }
                      tiempo={register.tiempocom}
                      xs={12}
                      md={4}
                      lg={4}
                      xl={4}
                    ></OrdenLista>
                  );
                })}
              </Row>
            </Container>
            {ordenToTicket ? (
              <>
                <Ticket
                  orden={ordenToTicket}
                  registro={register}
                  show={showTicket}
                  handleClose={handleCloseTicket}
                  impresion={impresion}
                  setImpresion={setImpresion}
                ></Ticket>
              </>
            ) : (
              <></>
            )}
            <IngresoManual
              show={show}
              handleClose={handleClose}
              cajaID={cajaID}
              userNew={newUserOrden}
            ></IngresoManual>
          </>
        ) : (
          <>
            <br />
            <br />
            <Row>
              <Col md={6}>
                <Form.Group controlId="MPK">
                  <Form.Label>
                    Fondo:{" "}
                    <i
                      title="Fondo de caja para iniciar"
                      className="bx bxs-info-circle icon bx-xs"
                      onClick={handleInfo}
                    ></i>
                  </Form.Label>
                  <Form.Control
                    placeholder="0.00"
                    className="mrg-costos"
                    onChange={handleChange}
                    value={cajadata?.fondo}
                    name="fondo"
                    required
                    type="number"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="AT">
                  <Form.Label>
                    Tipo de cambio:{" "}
                    <i
                      title="Tipo de cambio para dolares"
                      className="bx bxs-info-circle icon bx-xs"
                      onClick={handleInfo}
                    ></i>
                  </Form.Label>
                  <Form.Control
                    placeholder="0.00"
                    className="mrg-costos"
                    onChange={handleChange}
                    value={cajadata?.tipocambio}
                    name="tipocambio"
                    required
                    type="number"
                  />
                </Form.Group>
              </Col>
            </Row>
            <br />
            <button
              onClick={createCaja}
              id="new-cajaBtn"
              className="newbutton-style filled"
              style={{}}
            >
              INICAR CAJA
            </button>
          </>
        )}
        <Modal2
          style={customModalInfoStyles}
          isOpen={infoModal}
          onRequestClose={() => setInfoModal(false)}
        >
          <p>{textInfo}</p>
          <button
            style={{ marginRight: 5 }}
            onClick={() => setInfoModal(false)}
          >
            Aceptar
          </button>
        </Modal2>
        <Modal
          style={customModalInfoStyles}
          show={registroNew}
          onHide={() => setRegistroNew(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {tipoRegistro === "entradas"
                ? "Nuevo registro de entrada"
                : "Nuevo registro de salida"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={6}>
                <Form.Group controlId="MPK">
                  <Form.Label>Descripcion: </Form.Label>
                  <Form.Control
                    placeholder="Descripcion del registro"
                    className="mrg-costos"
                    onChange={(e) =>
                      setRegistroData({
                        ...registroData,
                        descripcion: e.target.value,
                      })
                    }
                    value={registroData?.descripcion}
                    name="descripcion"
                    required
                    type="text"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="AT">
                  <Form.Label>Monto: </Form.Label>
                  <Form.Control
                    placeholder="0.00"
                    className="mrg-costos"
                    onChange={(e) =>
                      setRegistroData({
                        ...registroData,
                        monto: e.target.value,
                      })
                    }
                    value={registroData?.monto}
                    name="monto"
                    required
                    type="number"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Row className="justify-content-center">
              <button
                onClick={() => setRegistroNew(false)}
                className="newbutton-style filled"
              >
                Cancelar
              </button>
              <button onClick={saveRegistro} className="newbutton-style filled">
                Guardar registro
              </button>
            </Row>
          </Modal.Footer>
        </Modal>
        <Modal
          style={customModalInfoStyles}
          size="xl"
          show={resumen}
          onHide={() => setResumen(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Resumen de caja </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={6}>
                <h3>Empleado: {emplName ? emplName : "Administrador"}</h3>
              </Col>
              <Col md={6} style={{ textAlign: "right" }}>
                <h5>
                  Apertura:{" "}
                  {cajadata.fecha
                    ? formatTimestamp(cajadata.fecha).date +
                      " " +
                      formatTimestamp(cajadata.fecha).time +
                      " "
                    : ""}
                </h5>
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={7}>
                <>
                  <Row style={{ marginBottom: "20px", textAlign: "center" }}>
                    <h2>Total en caja</h2>
                  </Row>
                  <Row>
                    <Col md={8}>
                      <h6>Fondo inicial: </h6>
                    </Col>
                    <Col md={4} style={{ textAlign: "right" }}>
                      <h6>
                        $
                        {cajadata.fondo
                          ? parseFloat(cajadata.fondo).toFixed(2)
                          : "0.00"}{" "}
                        MXN
                      </h6>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={8}>
                      <h6>Total de ventas en Efectivo: </h6>
                    </Col>
                    <Col md={4} style={{ textAlign: "right" }}>
                      <h6>${totalEfectivo} MXN</h6>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={8}>
                      <h6>Total de entradas: </h6>
                    </Col>
                    <Col md={4} style={{ textAlign: "right" }}>
                      <h6>
                        $
                        {entradas
                          ? entradas
                              .reduce((acom, num) => {
                                return acom + num.monto;
                              }, 0)
                              .toFixed(2)
                          : "0.00"}{" "}
                        MXN
                      </h6>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={8}>
                      <h6>Total de salidas: </h6>
                    </Col>
                    <Col md={4} style={{ textAlign: "right" }}>
                      <h6>
                        -$
                        {salidas
                          ? salidas
                              .reduce((acom, num) => {
                                return acom + num.monto;
                              }, 0)
                              .toFixed(2)
                          : "0.00"}{" "}
                        MXN
                      </h6>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={8}>
                      <h6>Devoluciones de efectivo: </h6>
                    </Col>
                    <Col md={4} style={{ textAlign: "right" }}>
                      <h6>
                        -$
                        {totalCancelacionesEfectivo} MXN
                      </h6>
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    <Col md={8}>
                      <h5>Total en caja: </h5>
                    </Col>
                    <Col md={4} style={{ textAlign: "right" }}>
                      <h5>
                        $
                        {(
                          parseFloat(cajadata.fondo) +
                          parseFloat(totalEfectivo) -
                          parseFloat(
                            salidas.reduce((acom, num) => acom + num.monto, 0),
                          ) +
                          parseFloat(
                            entradas.reduce((acom, num) => acom + num.monto, 0),
                          ) -
                          parseFloat(totalCancelacionesEfectivo)
                        ).toFixed(2)}{" "}
                        MXN
                      </h5>
                    </Col>
                  </Row>
                </>
                <>
                  <Row style={{ marginBottom: "20px", textAlign: "center" }}>
                    <h2>Total de ventas</h2>
                  </Row>
                  <Row>
                    <Col md={8}>
                      <h6>Total de ventas en Efectivo: </h6>
                    </Col>
                    <Col md={4} style={{ textAlign: "right" }}>
                      <h6>${totalEfectivo} MXN</h6>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={8}>
                      <h6>Total de ventas con tarjeta: </h6>
                    </Col>
                    <Col md={4} style={{ textAlign: "right" }}>
                      <h6>${totalTarjeta} MXN</h6>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={8}>
                      <h6>Total de cancelaciones/devoluciones: </h6>
                    </Col>
                    <Col md={4} style={{ textAlign: "right" }}>
                      <h6>-${totalCancelaciones} MXN</h6>
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    <Col md={8}>
                      <h5>Total: </h5>
                    </Col>
                    <Col md={4} style={{ textAlign: "right" }}>
                      <h5>
                        $
                        {(
                          parseFloat(totalEfectivo) +
                          parseFloat(totalTarjeta) -
                          parseFloat(totalCancelaciones)
                        ).toFixed(2)}{" "}
                        MXN
                      </h5>
                    </Col>
                  </Row>
                </>
              </Col>
              <Col md={5}>
                <Row>
                  <Col md={12}>
                    <h3 style={{ textAlign: "center" }}>Entradas </h3>
                  </Col>
                  <Col md={12}>
                    {entradas
                      .filter((e) => {
                        return e.monto !== 0;
                      })
                      .map((ent) => (
                        <Row>
                          <Col
                            md={3}
                            style={{ textAlign: "left" }}
                            key={ent.id}
                          >
                            <h6>{convertToDate(ent.fecha)}</h6>
                          </Col>
                          <Col md={5} key={ent.id}>
                            <h6>{ent.descripcion}</h6>
                          </Col>
                          <Col md={4} style={{ textAlign: "right" }}>
                            <h6>${ent.monto.toFixed(2)} MXN</h6>
                          </Col>
                        </Row>
                      ))}
                    <hr />
                    <Row>
                      <Col md={8} style={{ textAlign: "left" }}>
                        <h6>Total: </h6>
                      </Col>
                      <Col md={4} style={{ textAlign: "right" }}>
                        <h6>
                          $
                          {entradas
                            ? entradas
                                .reduce((acom, num) => acom + num.monto, 0)
                                .toFixed(2)
                            : "0.00"}{" "}
                          MXN
                        </h6>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <br />
                <br />
                <Row>
                  <Col md={12}>
                    <h3 style={{ textAlign: "center" }}>Salidas </h3>
                  </Col>
                  <Col md={12}>
                    {salidas
                      .filter((e) => {
                        return e.monto !== 0;
                      })
                      .map((ent) => (
                        <Row>
                          <Col
                            md={3}
                            style={{ textAlign: "left" }}
                            key={ent.id}
                          >
                            <h6>{convertToDate(ent.fecha)}</h6>
                          </Col>
                          <Col md={5} key={ent.id}>
                            <h6>{ent.descripcion}</h6>
                          </Col>
                          <Col md={4} style={{ textAlign: "right" }}>
                            <h6>${ent.monto.toFixed(2)} MXN</h6>
                          </Col>
                        </Row>
                      ))}
                    <hr />
                    <Row>
                      <Col md={8} style={{ textAlign: "left" }}>
                        <h6>Total: </h6>
                      </Col>
                      <Col md={4} style={{ textAlign: "right" }}>
                        <h6>
                          $
                          {salidas
                            ? salidas
                                .reduce((acom, num) => acom + num.monto, 0)
                                .toFixed(2)
                            : "0.00"}{" "}
                          MXN
                        </h6>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <h3 style={{ textAlign: "center" }}>Puntos</h3>
                  </Col>
                  <Col md={12}>
                    <Row>
                      <Col md={7} style={{ textAlign: "left" }}>
                        <h6>Total de puntos canjeados: </h6>
                      </Col>
                      <Col md={5} style={{ textAlign: "right" }}>
                        <h6>{puntosCanjeados} puntos</h6>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={7} style={{ textAlign: "left" }}>
                        <h6>Total de puntos otorgados: </h6>
                      </Col>
                      <Col md={5} style={{ textAlign: "right" }}>
                        <h6>{puntosOtorgados} puntos</h6>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col md={12}>
                    <h3 style={{ textAlign: "center" }}>MercadoPago</h3>
                  </Col>
                  <Col md={12}>
                    <Row>
                      <Col md={7} style={{ textAlign: "left" }}>
                        <h6>Total de ventas con MercadoPago: </h6>
                      </Col>
                      <Col md={5} style={{ textAlign: "right" }}>
                        <h6>$ {totalMercadoPago} MXN</h6>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer style={{ justifyContent: "space-between" }}>
            <div>
              <button onClick={Imprimir} className="newbutton-style filled">
                Imprimir ticket
              </button>
              {/* <button
              // onClick={saveRegistro}
              className="newbutton-style filled"
            >
              Exportar a excel
            </button> */}
            </div>
            <div>
              <button
                onClick={() => setResumen(false)}
                className="newbutton-style non-filled-text"
                style={{ backgroundColor: "#FFFFFF", color: "#000" }}
              >
                Cancelar
              </button>
              <button onClick={saveCierre} className="newbutton-style filled">
                Realizar cierre
              </button>
            </div>
          </Modal.Footer>
        </Modal>
        <Modal show={modQr} onHide={() => setModQr(false)}>
          <ModalHeader>Verificar ordenes</ModalHeader>
          <ModalBody>
            Escanee el QR para mostrar sus ordenes.
            <div id="project-qr" className="row">
              <div className="col-sm-12">
                <div className="center">
                  <img
                    className="qr-code"
                    style={{
                      width: "100px !important",
                      height: "100px !important",
                    }}
                    src={
                      "https://quickchart.io/qr?text=TREC-" +
                      register.id +
                      "&size=300"
                    }
                    alt=""
                  ></img>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              variant="secondary"
              onClick={() => {
                setModQr(false);
              }}
            >
              CERRAR
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                var content = document.getElementById("project-qr");
                var pri =
                  document.getElementById("ifmcontentTicket").contentWindow;
                pri.document.open();
                pri.document.write(content.innerHTML);
                pri.document.close();
                pri.focus();
                pri.print();
              }}
            >
              IMPRIMIR
            </Button>
          </ModalFooter>
        </Modal>
        <Modal show={modQrNuevo} onHide={() => setModQrNuevo(false)}>
          <ModalHeader>Nueva orden</ModalHeader>
          <ModalBody>
            Escanee el QR para generar una orden nueva con su usuario.
            <div id="project-qr-TIMN" className="row">
              <div className="col-sm-12">
                <div className="center">
                  <img
                    className="qr-code"
                    style={{
                      width: "100px !important",
                      height: "100px !important",
                    }}
                    src={
                      "https://quickchart.io/qr?text=TIMN-" +
                      register.id +
                      "&size=300"
                    }
                    alt=""
                  ></img>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              variant="secondary"
              onClick={() => {
                setModQrNuevo(false);
              }}
            >
              CERRAR
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                var content = document.getElementById("project-qr-TIMN");
                var pri =
                  document.getElementById("ifmcontentTicket").contentWindow;
                pri.document.open();
                pri.document.write(content.innerHTML);
                pri.document.close();
                pri.focus();
                pri.print();
              }}
            >
              IMPRIMIR
            </Button>
          </ModalFooter>
        </Modal>
        <Modal
          style={customModalInfoStyles}
          show={busquedac}
          onHide={() => setBusquedac(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Buscar orden con codigo</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={12}>
                <Form.Group controlId="MPK">
                  <Form.Label>Codigo de orden: </Form.Label>
                  <Form.Control
                    placeholder="Codigo"
                    className="mrg-costos"
                    onChange={(e) => {
                      setCodigoc(e.target.value);
                    }}
                    value={codigoc}
                    name="descripcion"
                    required
                    type="text"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Row className="justify-content-center">
              <button
                onClick={() => {
                  setBusquedac(false);
                  setCodigoc("");
                }}
                className="newbutton-style filled"
              >
                Cancelar
              </button>
              <button
                onClick={realizarBusqueda}
                className="newbutton-style filled"
              >
                Buscar
              </button>
            </Row>
          </Modal.Footer>
        </Modal>
        <iframe
          title="ifmcontentstoprint"
          className="iframePrint"
          id="ifmcontentstoprint"
        ></iframe>
        <iframe
          title="ifmcontentTicket"
          className="iframePrint"
          id="ifmcontentTicket"
        ></iframe>
      </Container>
      {ordenToView ? (
        <ViewPedidoNew
          show={showPedido}
          handleClose={handleClosePedido}
          orden={ordenToView}
          cajaID={cajaID}
          openTicket={handleShowTicket}
          pagar={pagar}
        />
      ) : (
        <></>
      )}
    </>
  );
}
